import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/header.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/mirakl-network-canvas.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/sections/contact-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetLanguage"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/set-language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustbedrijfWidget"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/trustbedrijf-widget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebMcpTools"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/webmcp-tools.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
